import { render, staticRenderFns } from "./WidgetExample.vue?vue&type=template&id=b59c68f6&"
import script from "./WidgetExample.vue?vue&type=script&lang=js&"
export * from "./WidgetExample.vue?vue&type=script&lang=js&"
import style0 from "./WidgetExample.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports